import {
  ClickAwayListener,
  Grid,
  IconButton,
  Tooltip
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';
import CustomizedTypography from '../CustomizedTypography';
import useStyles from './styles';
import { CustomizedTooltipProps } from './types';

const CustomizedTooltip: React.FC<CustomizedTooltipProps> = (props) => {
  const classes = useStyles({
    ...props
  });

  const {
    callback,
    zIndex,
    closeButton,
    minWidth,
    maxWidth,
    gutter,
    ClickAwayListner,
    ...rest
  } = props;

  return (
    <ClickAwayListener
      mouseEvent={props.open ? 'onMouseUp' : false}
      touchEvent={false}
      onClickAway={(e) => {
        e.stopPropagation();
        if (ClickAwayListner && !closeButton) {
          props.onClose && props.onClose(e);
        }
      }}
    >
      <Tooltip
        {...rest}
        onClose={(e) => {
          e.stopPropagation();
          props.onClose && props.onClose(e);
        }}
        title={
          props.variant === 'paper' ? (
            <React.Fragment>
              {closeButton && (
                <IconButton
                  className={classes.closeButton}
                  onClick={(e) => {
                    props.onClose && props.onClose(e);
                    callback && callback();
                  }}
                >
                  <Close fontSize="small" />
                </IconButton>
              )}
              {props.title}
            </React.Fragment>
          ) : (
            <Grid container component="div" onClick={props.onClick}>
              <Grid
                container
                style={{ marginRight: props.closeButton ? 24 : undefined }}
              >
                {React.isValidElement(props.title) ? (
                  props.title
                ) : (
                  <CustomizedTypography
                    className="title"
                    variant="body2"
                    fontWeight="500"
                    style={{ wordBreak: 'break-all' }}
                  >
                    {props.title}
                  </CustomizedTypography>
                )}
              </Grid>

              {closeButton && (
                <IconButton
                  disableTouchRipple
                  disableRipple
                  disableFocusRipple
                  className={classes.closeButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onClose && props.onClose(e);
                    callback && callback();
                  }}
                >
                  <Close fontSize="small" color="secondary" />
                </IconButton>
              )}
            </Grid>
          )
        }
        classes={{
          tooltip: classes.tooltip,
          arrow: classes.arrow,
          tooltipPlacementTop: classes.tooltipPlacementTop,
          tooltipPlacementBottom: classes.tooltipPlacementBottom,
          popper: classes.popper
        }}
      >
        <div>{props.children}</div>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default CustomizedTooltip;
